import React, { useEffect, useRef } from "react";
import "./Etiquetas.css";
import emailjs from '@emailjs/browser';

const Etiquetas = () => {
    const bannerRef = useRef(null);

useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) bannerRef.current.classList.add("visible");
            },
            { threshold: 0.3 }
        );
        if (bannerRef.current) observer.observe(bannerRef.current);
    }, []);

    return (
        <section className="etiquetas">
            {/* === SECCIÓN 1: Banner con animación === */}
            <p className="subtitle">we make it <span>happen.</span></p>
            <div className="etiquetas-banner" ref={bannerRef}>

                <div className="etiquetas-banner-texto">
                    <img src="/images/logo/MotiPuntos.svg" style={{ height: '0.7rem' }}></img>
                    <h3>Impresión de <br></br>etiquetas y mangas<br></br> termoencogibles</h3>
                    <p className="p-etiquetas">Imagina sin límites</p>
                </div>
                <img src="/images/etiquetas/imagen-banner.png" alt="espectacular" className="etiquetas-espectacular" />
            </div>

            {/* === SECCIÓN 2: Texto + Imagen edificio === */}
            <div className="etiquetas-info">

                <p className="etiquetas-subtitle">we make it <span>happen.</span></p>
                <div className="etiquetas-info-contenido">
                    <div className="etiquetas-info-texto">
                        <div className="etiquetas-tag"> <img src="/images/etiquetas/etiqueta-tag.svg" style={{ height: '1rem' }}></img> Etiquetas & Mangas</div>
                        <h2>
                            ¡Etiquetas y mangas,
                            <span>  otro rollo!</span>
                        </h2>
                        <p>
                            Con nuestros materiales, tamaños, formas y terminados, las posibilidades son infinitas.
                            Creamos etiquetas y mangas que transforman cualquier producto en una experiencia visual única.
                        </p>
                        <p className="etiquetas-cta">
                            En Moti Digital lo hacemos posible, <a href="#cotiza">solicita tu cotización:</a>
                        </p>
                        <div className="etiquetas-input-wrapper">
                            <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const form = e.target;
                                    const button = form.querySelector("button");
                                    const input = form.querySelector("input");

                                    button.disabled = true;
                                    const originalText = button.textContent;
                                    button.textContent = "Enviando...";

                                    try {
                                        const serviceID = "service_lxg5sht";
                                        const templateID = "template_epehkcc";
                                        const publicKey = "4f0iRLKGvmXsd0ASA";

                                        const params = {
                                            from_name: input.value,
                                            message: `Me interesan sus productos de Etiquetas y mangas termoencogibles. Me pueden contactar al correo ${input.value}, me estoy contactando desde motidigital.com `,
                                        };

                                        console.log("📤 Enviando con EmailJS...");
                                        console.log({ serviceID, templateID, publicKey, params });

                                        const res = await emailjs.send(serviceID, templateID, params, publicKey);
                                        console.log("✅ Respuesta EmailJS:", res);

                                        if (res.status === 200) {
                                            button.textContent = "Enviado ✔";
                                            input.value = "";
                                            setTimeout(() => {
                                                button.textContent = originalText;
                                                button.disabled = false;
                                            }, 3000);
                                        } else {
                                            throw new Error("Error en el envío");
                                        }
                                    } catch (error) {
                                        console.error("❌ Error al enviar con EmailJS:", error);

                                        button.textContent = "Error ✖";
                                        setTimeout(() => {
                                            button.textContent = originalText;
                                            button.disabled = false;
                                        }, 2500);
                                    }
                                }}
                            >
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Tu correo electrónico"
                                    required
                                />
                                <button type="submit">Empecemos</button>
                            </form>
                        </div>
                    </div>

                    <div className="etiquetas-info-imagen">
                        <img src="/images/etiquetas/botella.png" alt="Etiquetas en edificio" />
                    </div>
                </div>
            </div>
            <div className="etiquetas-final">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="etiquetas-dots" />
                <h2>
                    ¿Listo para hacer crecer <br />
                    <span>tu empresa?</span>
                </h2>

                {/* Doble marquee - VERSIÓN SIMPLE */}
                <div className="etiquetas-marquees">
                    <div className="etiquetas-marquee etiquetas-line1">
                        <span>
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·

                        </span>
                        <span>
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                            IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE · IMPRESIÓN DE ·
                        </span>
                    </div>

                    <div className="etiquetas-marquee etiquetas-line2">
                        <span>
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                        </span>
                        <span>
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                            MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO · MANGAS TERMOENCOGIBLES · ETIQUETAS EN ROLLO ·
                        </span>
                    </div>
                </div>

                {/* Slider semicircular */}
                <div className="etiquetas-slider">
                    <div className="etiquetas-slider-track">
                        <img src="/images/etiquetas/slider/1.png" alt="img1" />
                        <img src="/images/etiquetas/slider/2.png" alt="img2" />
                        <img src="/images/etiquetas/slider/3.png" alt="img3" />
                        <img src="/images/etiquetas/slider/4.png" alt="img4" />
                        <img src="/images/etiquetas/slider/5.png" alt="img5" />
                    </div>
                </div>
            </div>
            {/* === SECCIÓN 3: Opción estratégica === */}
            <div className="etiquetas-opcion">
                <div className="etiquetas-opcion-card">
                    <div className="etiquetas-opcion-left">
                        <h2>¿Cuál elegir?</h2>
                        <p>Conoce la diferencia entre<br />etiquetas y mangas.</p>
                        <button className="etiquetas-btn-cotizar">Cotizar ahora</button>
                    </div>

                    <div className="etiquetas-opcion-right">
                        <div className="etiquetas-opcion-item">
                            <div className="etiquetas-icon" style={{ backgroundColor: "#f3c7ce" }}>
                                <img src="/images/etiquetas/icon-mangas.svg" alt="Mangas" />
                            </div>
                            <div>
                                <h4>Mangas termoencogibles</h4>
                                <ul>
                                    <li>Envolventes, cubren todo el producto (360°).</li>
                                    <li>Ofrecen un diseño más llamativo y personalizable.</li>
                                    <li>Requieren de calor para colocarse.</li>
                                </ul>
                            </div>
                            <img src="/images/etiquetas/lata-manga.png" alt="Manga termoencogible" className="etiquetas-producto" />
                        </div>

                        <div className="etiquetas-opcion-item">
                            <div className="etiquetas-icon" style={{ backgroundColor: "#c9e7e4" }}>
                                <img src="/images/etiquetas/icon-rollo.svg" alt="Etiquetas en rollo" />
                            </div>
                            <div>
                                <h4>Etiquetas en rollo</h4>
                                <ul>
                                    <li>Ideales para superficies planas o curvas.</li>
                                    <li>Se aplican directamente al producto.</li>
                                    <li>Presentación en rollo o planilla.</li>
                                </ul>
                            </div>
                            <img src="/images/etiquetas/botella-rollo.png" alt="Etiqueta en rollo" className="etiquetas-producto" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="etiquetas-faq">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="etiquetas-dots" />
                <h2>Preguntas frecuentes</h2>
                <div className="etiquetas-faq-contenedor">
                    {/* Lado izquierdo - Acordeón */}
                    <div className="etiquetas-faq-lista">
    <details>
        <summary>¿Cómo puedo cotizar etiquetas?</summary>
        <p>
            Puedes comprar y diseñar tus etiquetas directamente en nuestro tienda en línea. 
            Si requieres asesoría personalizada o etiquetas con acabados especiales, contáctanos 
            y un ejecutivo te ayudará.
        </p>
    </details>

    <details>
        <summary>¿Qué materiales utilizan para etiquetas?</summary>
        <p>
            Trabajamos con una amplia variedad de materiales incluyendo papel couché, vinilo adhesivo, 
            materiales transparentes y materiales rígidos para diferentes aplicaciones.
        </p>
    </details>

    <details>
        <summary>¿Entre qué acabados puedo elegir?</summary>
        <p>
            Ofrecemos acabados como barniz UV selectivo, laminado mate o brillante, relieves, 
            troquelados especiales y hot stamping para darle un toque premium a tus etiquetas.
        </p>
    </details>

    <details>
        <summary>¿Cuál es la diferencia entre rollo y planilla?</summary>
        <p>
            El rollo es ideal para aplicaciones automáticas en líneas de producción, mientras que 
            la planilla se utiliza para aplicaciones manuales o procesos de corte individual.
        </p>
    </details>

    <details>
        <summary>¿Cuentan con servicio de diseño?</summary>
        <p>
            Sí, nuestro equipo de diseñadores puede ayudarte a crear o adaptar tus diseños para 
            garantizar que cumplan con los requisitos técnicos de impresión y sean visualmente atractivos.
        </p>
    </details>

    <details>
        <summary>¿Tienen mínimos de compra?</summary>
        <p>
            Sí, manejamos mínimos de compra que varían según el material y acabados seleccionados. 
            Contáctanos para conocer los detalles específicos según tu proyecto.
        </p>
    </details>
</div>

                    {/* Lado derecho - Contacto */}
                    <div className="etiquetas-faq-contacto">
                        <h3>¿Tienes más dudas?</h3>
                        <p>No dudes en contactarnos para más información.</p>

                        <div className="etiquetas-contacto-email">
                            <div className="etiquetas-email-box">
                                <img src="/images/etiquetas/mail.svg" alt="email" />
                                <span>VMUNOZ@MOTIDIGITAL.COM</span>
                                <button>Agendar una llamada</button>
                            </div>
                            <button className="etiquetas-btn-whatsapp"> Cotiza tu proyecto</button>
                        </div>

                        <div className="etiquetas-faq-img">
                            <img src="/images/granformato/faq-banner.png" alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>

        </section>

    );
};

export default Etiquetas;